import styled from 'styled-components';
import { Col, Row } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

import MQ from '../../../../attrs/mq';

export const StyledRow = styled(Row)`
  margin-bottom: 1.5rem;

  :last-child {
    margin-bottom: 0;
  }
`;

export const StyledCol = styled(Col)`
  display: flex;
  margin-bottom: 0.5rem;

  ${MQ.sm`
    margin-bottom: 0rem;

    &:last-child {
      justify-content: flex-end;
      margin-bottom: 0;
    }
  `}
`;

export const InfoIcon = styled(InfoCircleOutlined)`
  margin-left: 5px;
  margin-top: 4px;
  opacity: 0.5;
`;
